import JSONbig from 'json-bigint'

import { AddressCandidate, FormDataCustom, NovuSubscriberInfo, ProductLicense } from '../../types'
import { UserDetails } from '../../user/domain/user.types'
import apiClient from '../apiClient'
import { ENDPOINTS } from '../endpoints'

export const fetchNovuSubscriberInfo = async (): Promise<NovuSubscriberInfo> => {
  const response = await apiClient.get<NovuSubscriberInfo>('/users/novuSubscriberInfo')
  return response.data
}

export const fetchUserDetails = async (): Promise<UserDetails> => {
  const response = await apiClient.get<UserDetails>('/users/details')
  return response.data
}

export const siteActiveLicenses = {
  list: async (siteId: string): Promise<ProductLicense[]> => {
    const response = await apiClient.get<ProductLicense[]>(ENDPOINTS.sites.getProductLicenses(siteId))
    return response.data
  },
}

export const fetchAddressCandidate = async (siteId: string): Promise<AddressCandidate[]> => {
  const response = await apiClient.get<AddressCandidate[]>('/PmpServerAddressCandidates/user', { params: { siteId } })
  return response.data
}

export const createZohoTicket = async (formData: FormDataCustom) => {
  const [firstName, lastName] = formData.name.split(' ', 2)

  const description = '\nMill Name : ' + formData.millName + '\n' + formData.problemDetail

  const ticket = {
    subject: formData.title,
    departmentId: '220064000000006907',
    contact: {
      email: formData.email,
      phone: formData.phone,
      firstName: firstName,
      lastName: lastName,
    },
    description: description,
  }

  const response = await apiClient.post('/ZohoTicket/createTicket', ticket, {
    headers: {
      'Content-Type': 'application/json',
    },
    transformResponse: (data) => JSONbig.parse(data),
  })
  return response.data
}

export const attachFiles = async (ticketId: string, files: File[]) => {
  const formDataToSend = new FormData()
  formDataToSend.append('ticketId', ticketId)

  files.forEach((file) => {
    formDataToSend.append('Files', file)
  })

  await apiClient.post('/ZohoTicket/addFiles', formDataToSend, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const updateUserName = async (firstName: string, lastName: string) => {
  const updatedUser = { firstName: firstName, lastName: lastName }

  await apiClient.put('/users/name', updatedUser, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const updateUserPhone = async (phone: string) => {
  const updatedUser = { phoneNumber: phone }

  await apiClient.put('/users/phone', updatedUser, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const updateUserLanguage = async (language: string) => {
  const updatedUser = { language: language }

  return apiClient.put('/users/language', updatedUser, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
